import { useEffect, useState } from "react";

import Page from "./Page";
import AccountTable from "@/components/molecules/files/tables/AccountTable";
// import { GenAiContext } from "@/client/context";
// import { useRecoilValue } from "recoil";
// import { accessTokenState } from "@/client/state";
import { useApi } from "@/client/api";
import { toQueryString } from "@/utils/hash";
import { useRecoilState } from "recoil";
import { settingsState } from "@/state/settings";

export type IAccount = {
  id: number;
  company_name: string;
  created_at: string;
  status: string;
  application_form_crawling?: string;
  application_form_filename?: string;
  application_form_url?: string;
  company_profile_crawling?: string;
  company_profile_filename?: string;
  company_profile_url?: string;
  financial_statement_crawling?: string;
  financial_statement_filename?: string;
  financial_statement_url?: string;
  other_file_filename?: string;
  other_file_url?: string;
};

type IAccountWithPagination = {
  data: {
    data: IAccount[];
    total_pages: number;
  };
};

export default function Account() {
  // const accessToken = useRecoilValue(accessTokenState);
  // const apiClient = useContext(GenAiContext);

  const [_, setSettings] = useRecoilState(settingsState);

  useEffect(() => {
    setSettings((prev) => {
      return {
        ...prev,
        isSideBarOpen: true,
        isTextEditorOpen: false,
        isChatHistoryOpen: false,
      };
    });
  }, []);

  const [filters, setFilters] = useState({
    search: "",
    sort_order: "desc",
    sort_by: "created_at",
    page: 1,
    limit: 10,
  });

  // const [accountData, setAccountData] = useState<{
  //   data: IAccount[];
  //   total_pages: number;
  // }>({
  //   data: [],
  //   total_pages: 0,
  // });

  // const [isLoading, setIsLoading] = useState(true);
  // const [error, setError] = useState<Error | null>(null);

  // const getAccountData = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await apiClient.getAllAccounts(accessToken);
  //     setAccountData(response?.data || []);
  //     console.log("Data: ", response?.data);
  //     setError(null);
  //   } catch (err) {
  //     console.error("Failed to get account data.", err);
  //     setError(err as Error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  function useAccountData(filters: {
    search: string;
    sort_order: string;
    sort_by: string;
    page: number;
    limit: number;
  }) {
    const { data, error, isLoading, mutate } = useApi<IAccountWithPagination>(
      filters ? `/api/account/all${toQueryString(filters, true)}` : null,
      { revalidateOnFocus: false }
    );

    return { accountData: data, error, isLoading, refetch: mutate };
  }

  const { accountData, error, isLoading, refetch } = useAccountData(filters);

  // fetch on mount
  // useEffect(() => {
  //   getAccountData();
  // }, []);

  return (
    <Page>
      <AccountTable
        accounts={accountData?.data?.data}
        // accounts={[]}
        paging={accountData?.data?.total_pages}
        error={error?.message}
        isLoading={isLoading}
        onAccountUpdated={refetch} // Child component can trigger refetch
        filters={filters}
        setFilters={setFilters}
      />
    </Page>
  );
}
